import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

const zValidateSearch = z.object({
  cluster: z.number().optional().catch(undefined),
});

export const Route = createFileRoute('/verwaltung/{-$adminLevelId}/meldungen/auswahl')({
  validateSearch: zValidateSearch,
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: RouteComponent,
});

function RouteComponent() {
  // Rendered via match inside BackendMap as BackendReportSelect

  return null;
}
